function isScrollable(element, orientation = "vertical") {
  if (element === null) {
    return false;
  }
  const scrollSize = orientation === "horizontal" ? element.scrollWidth : element.scrollHeight;
  const clientSize = orientation === "horizontal" ? element.clientWidth : element.clientHeight;
  return scrollSize > clientSize;
}
function canScrollTo(element, direction, {
  tolerance = 0.5
} = {}) {
  if (element === null) {
    return false;
  }
  if (direction === "left") {
    return element.scrollLeft > tolerance;
  }
  if (direction === "top") {
    return element.scrollTop > tolerance;
  }
  if (direction === "right") {
    const scrollable2 = isScrollable(element, "horizontal");
    const remainingScrollSpace2 = element.scrollWidth - (element.clientWidth + element.scrollLeft);
    const hasRemainingScrollableSpace2 = remainingScrollSpace2 > tolerance;
    return scrollable2 && hasRemainingScrollableSpace2;
  }
  const scrollable = isScrollable(element, "vertical");
  const remainingScrollSpace = element.scrollHeight - (element.scrollTop + element.clientHeight);
  const hasRemainingScrollableSpace = remainingScrollSpace > tolerance;
  return scrollable && hasRemainingScrollableSpace;
}

export { canScrollTo, isScrollable };
//# sourceMappingURL=scroll.mjs.map
